<template>

    <v-panel class="maxw-600">
        <template #title>CrowdPower Lifetime Deal</template>
        <template #body v-if="!completed">
            <v-notice key="intro" class="mb-30" title="The CrowdPower lifetime deal is a limited time offer and includes a fixed number of customers and monthly emails, depending on your code*" message="*You may also send unlimited emails within automations from your own SMTP server." />
            <v-alert :message="error" />
            <form v-if="!company" @submit.prevent="signupUnlock">
                <v-form-group dir="ver" label="Name">
                    <v-input autocomplete="name" :model="params.name" @input="params.name = $event" />
                </v-form-group>
                <v-form-group dir="ver" label="Company Name">
                    <v-input :model="params.company" @input="params.company = $event" />
                </v-form-group>
                <v-form-group dir="ver" label="Email Address">
                    <v-input type="email" autocomplete="email" :model="params.email" @input="params.email = $event" />
                </v-form-group>
                <v-form-group class="mb-30" dir="ver" label="Password">
                    <v-input type="password" :model="params.password" @input="params.password = $event" />
                </v-form-group>
                <v-form-group class="mb-30" dir="ver" label="Access Code">
                    <v-input :model="params.access_code" @input="params.access_code = $event" />
                </v-form-group>
                <v-button class="mb-30" btn-type="submit" :loading="loading" @click.native="signupUnlock" btn-block>Redeem Code</v-button>
            </form>
            <form v-else @submit.prevent="unlockSubscription">
                <v-form-group class="mb-30" dir="ver" label="Access Code">
                    <v-input :model="params.access_code" @input="params.access_code = $event" />
                </v-form-group>
                <v-button class="mb-30" btn-type="submit" :loading="loading" @click.native="unlockSubscription" btn-block>Redeem Code</v-button>
            </form>
            <div v-if="!company">
                <p class="small text-center mb-5">Have a CrowdPower account? <router-link :to="{ name: 'login', query: { r: 'ltd' } }">Log In</router-link></p>
                <p class="small text-center">By signing up, you agree to our <a :href="url + '/terms'">Terms of Service</a>. This offer is available for a limited time. First time subscribers only.</p>
            </div>
            <div v-else>
                <p class="small text-center">This offer is available for a limited time. First time subscribers only.</p>
            </div>
         </template>
        <template #body v-else>
            <v-notice key="complete" class="mb-30" type="success" title="Lifetime Deal Unlocked!" />
            <v-button @click.native="$router.push({ name: 'console' })" btn-block>Continue</v-button>
        </template>
    </v-panel>

</template>

<script>

import AuthApi from '@api/AuthApi';
import CompanyApi from '@api/CompanyApi';
import moment from 'moment';

export default {

    data() {
        return {
            url: process.env.VUE_APP_URL,
            loading: false,
            error: null,
            completed: false,
            params: {
                timezone: moment.tz.guess(),
                access_code: this.$route.params.code,
            },
        }
    },

    computed: {

        company() {
            return this.$store.getters.company;
        },

    },

    mounted() {
        if (!this.company) {
            if (this.$recaptchaInstance) {
                this.$recaptchaInstance.showBadge();
            }
            window.addEventListener('load', () => {
                this.$recaptchaInstance.showBadge();
            });
        }
    },

    beforeDestroy() {
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.hideBadge();
        }
    },

    methods: {

        async signupUnlock() {
            if (this.loading) return;
            this.loading = true;
            await this.$recaptchaLoaded();
            this.params.recaptcha = await this.$recaptcha('signup');
            AuthApi.signupUnlock(this.params)
                .then((response) => {
                    this.loading = false;
                    this.completed = true;
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        unlockSubscription() {
            if (this.loading) return;
            this.loading = true;
            CompanyApi.unlockSubscription(this.company.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.completed = true;
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

    },

}

</script>
